import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* uploadv3(action) {
  var payload = {
    action: "portal/finishUpload3",
    assetId: action.assetId,
  };

  yield put(serverRequest(payload));
}

export default uploadv3;
